import React from "react"
import useMediaQuery from "@mui/material/useMediaQuery"

import FooterLinkCentering from "molecules/FooterLinkCentering"
import FooterLinkLeftAdjust from "molecules/FooterLinkLeftAdjust"

const Footer = () => {
  return useMediaQuery("(min-width:640px)") ? (
    <FooterLinkCentering />
  ) : (
    <FooterLinkLeftAdjust />
  )
}

export default Footer
